import { useContext, useState, useEffect } from "react";
import Select from "react-select";
import { UserContext } from "../contexts/UserContext";
import Switch from "react-switch";
import { BsExclamationCircle } from "react-icons/bs";
import authService from "../services/authservices";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const options = [
  { value: "All Pair Selection", label: "All Pair Selection" },
  { value: "Individual Pair Selection", label: "Individual Pair Selection" },
];

const BotPopup = ({ handleBotClose, isBotconfig, userDetails }) => {
  const [activeNum, setActiveNum] = useState(1);
  const { theme } = useContext(UserContext);
  const [buttonLoader, setbuttonLoader] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const [user, setUser] = useState({
    tfaStatus: 0,
    email: null,
    uid: null,
    referralCode: null,
    referralUrl: null,
    displayname: null,
    country: null,
    isAuthenticated: false,
    botConfig: null,
  });
  const [otpSent, setOtpSent] = useState(false);
  const [timer, setTimer] = useState(300);
  const [resendLoader, setResendLoader] = useState(false);
  const [formData, setFormData] = useState({
    maxLimit: "",
    maxOpen: "",
    dailyLoss: "",
    lotPercentage: "",
    selectedOption: null,
    pairSelection: [],
    otp: "",
  });


  const [touched, setTouched] = useState({});
  const [pairOptions, setpairOptions] = useState([]);

  const showsuccessToast = (message) => {
    toast.dismiss();
    toast.success(message);
  };

  const showerrorToast = (message) => {
    toast.dismiss();
    toast.error(message);
  };

  useEffect(() => {
    fetchUserDetails();
    getTradepair();
  }, []);
  useEffect(() => {
    if (isBotconfig && userDetails?.botConfig) {
      setFormData({
        maxLimit: userDetails.botConfig.maxLimit || "",
        maxOpen: userDetails.botConfig.maxOpen || "",
        dailyLoss: userDetails.botConfig.dailyLoss || "",
        lotPercentage: userDetails.botConfig.lotPercentage || "",
        selectedOption: userDetails.botConfig.selectedOption
          ? {
              value: userDetails.botConfig.selectedOption,
              label: userDetails.botConfig.selectedOption,
            }
          : null,
        pairSelection: userDetails.botConfig.pairSelection
          ? userDetails.botConfig.pairSelection.map((pair) => ({
              value: pair,
              label: pair,
            }))
          : [],
        otp: "",
      });
      setChecked(userDetails.botConfig.isStoploss || false);
    } 
    else {
      if(userDetails?.botConfig.dailyLoss == null)
      {
          setFormData({
          maxLimit: "",
          maxOpen: "",
          dailyLoss: "",
          lotPercentage: "",
          selectedOption: null,
          pairSelection: [],
          otp: "",
          });
          setChecked(false);
      }
      
    }
  }, [isBotconfig, userDetails]);

  const fetchUserDetails = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const data = await authService.getUserDetails(token);
        if (data && data.status) {
          const userDetails = {
            isAuthenticated: true,
            tfaStatus: data.tfastatus,
            email: data.email,
            displayname: data.displayname,
            country: data.country,
            uid: data.uid,
            referralCode: data.referralCode,
            referralUrl: data.referralUrl,
            botConfig: data.botConfig,
          };
          setUser(userDetails);
        } else {
          setUser({
            isAuthenticated: false,
            tfaStatus: 0,
            email: null,
            uid: null,
            referralCode: null,
            referralUrl: null,
            botConfig: null,
          });
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
        setUser({
          isAuthenticated: false,
          tfaStatus: 0,
          email: null,
          uid: null,
          referralCode: null,
          referralUrl: null,
          botConfig: null,
        });
      }
    } else {
      setUser({
        isAuthenticated: false,
        tfaStatus: 0,
        email: null,
        uid: null,
        referralCode: null,
        referralUrl: null,
        botConfig: null,
      });
    }
    setLoading(false);
  };

  const getTradepair = async () => {
    try {
      const data = await authService.getTradepair();

      if (data && data.status) {
        setpairOptions(data.data);
      } else {
        setpairOptions([]);
        showerrorToast(data?.Message || "Failed to fetch trade pairs.");
      }
    } catch (error) {
      console.error("Error fetching trade pairs:", error);
      showerrorToast("Something went wrong. Please try again later.");
    }
  };

  useEffect(() => {
    let countdown;
    if (otpSent && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setOtpSent(false);
      clearInterval(countdown);
    }
    return () => clearInterval(countdown);
  }, [timer, otpSent]);

  const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: theme === "dark" ? "transparent" : "#f9f9f9",
      border: `1px solid ${theme === "dark" ? "#2b3139" : "#ccc"}`,
      padding: "4px",
      color: theme === "dark" ? "#fff" : "#000",
      boxShadow: "none",
      outline: "none",
      fontSize: window.innerWidth < 400 ? "12px" : "16px",
    }),
    option: (styles, { isFocused }) => ({
      ...styles,
      color: theme === "dark" ? "#fff" : "#000",
      backgroundColor: isFocused
        ? theme === "dark"
          ? "#444"
          : "#e0e0e0"
        : theme === "dark"
        ? "#181a20"
        : "#fff",
      cursor: "pointer",
      fontSize: window.innerWidth < 400 ? "12px" : "16px",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: theme === "dark" ? "#fff" : "#000",
      fontSize: window.innerWidth < 400 ? "12px" : "16px",
    }),
  };

  const handleChange = (nextChecked) => setChecked(nextChecked);

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    const keyMap = {
      "max-limit": "maxLimit",
      "max-open": "maxOpen",
      "daily-loss": "dailyLoss",
      "lot-percentage": "lotPercentage",
      otp: "otp",
    };

    const key = keyMap[id] || id;

    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleSelectChange = () => {}; // not used anymore
const handlePairSelect = () => {}; // not used anymore

useEffect(() => {
  // Automatically set "All Pair Selection" with all pairs
  setFormData((prev) => ({
    ...prev,
    selectedOption: { value: "All Pair Selection", label: "All Pair Selection" },
    pairSelection: pairOptions,
  }));
}, [pairOptions]);

  const sendOtp = async () => {
    setResendLoader(true);

    // example: if your user data is stored globally or in props
    if (!user?.email) {
      setResendLoader(false);
      showerrorToast(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">
            User email is not available. Please try again.
          </p>
        </div>
      );
      return;
    }

    // Validate that required bot configuration fields are filled before OTP
    const validationErrors = validateStep(3);
    if (Object.keys(validationErrors).length > 0) {
      setResendLoader(false);
      showerrorToast(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">
            Please complete all required configuration fields before sending
            OTP.
          </p>
        </div>
      );
      return;
    }

    try {
      const response = await authService.sendBotOtp({ email: user.email });

      if (response.status) {
        setResendLoader(false);
        showsuccessToast(
          <div className="toast-ml">
            <h4 className="toast-title">Success!</h4>
            <p className="toast-message">OTP sent successfully!</p>
          </div>
        );
        setOtpSent(true);
        setTimer(300);
      } else {
        setResendLoader(false);
        showerrorToast(
          <div className="toast-ml">
            <h4 className="toast-title">Error!</h4>
            <p className="toast-message">
              {response.Message
                ? response.Message
                : "Failed to send OTP. Please try again."}
            </p>
          </div>
        );
      }
    } catch (error) {
      setResendLoader(false);
      showerrorToast(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">
            An error occurred while sending OTP. Please try again.
          </p>
        </div>
      );
    }
  };

  const validateStep = (step) => {
    const errors = {};
    if (step === 1) {
      if (!formData.maxLimit)
        errors.maxLimit = "Maximum order limit is required";
      if (!formData.maxOpen) errors.maxOpen = "Maximum daily open is required";
      if (!formData.dailyLoss)
        errors.dailyLoss = "Daily loss limit is required";
    } else if (step === 2) {
      if (!formData.lotPercentage)
        errors.lotPercentage = "Lot size percentage is required";
    }
    //  else if (step === 3) {
    //   if (!formData.selectedOption)
    //     errors.selectedOption = "Select a pair selection";
    //   if (
    //     formData.selectedOption?.value === "Individual Pair Selection" &&
    //     (!formData.pairSelection || formData.pairSelection.length === 0)
    //   ) {
    //     errors.pairSelection = "Select at least one pair";
    //   }
    // } 
    else if (step === 4) {
      if (!formData.otp) errors.otp = "Otp is required";
    }
    return errors;
  };

  const nextStep = () => {
    const errors = validateStep(activeNum);
    console.log("errors---",errors);
    setTouched((prev) => ({
      ...prev,
      ...Object.keys(errors).reduce((a, k) => ({ ...a, [k]: true }), {}),
    }));

    if (Object.keys(errors).length === 0) {
      setActiveNum((prev) => prev + 1);
    }
  };

  const prevStep = () => setActiveNum((prev) => prev - 1);

  const handleSubmit = async () => {
    const errors = validateStep(4);

    setTouched((prev) => ({
      ...prev,
      ...Object.keys(errors).reduce((a, k) => ({ ...a, [k]: true }), {}),
    }));

    if (Object.keys(errors).length > 0) return;

    setbuttonLoader(true);

    try {
      const payload = {
        otp: formData.otp,
        maxLimit: formData.maxLimit,
        maxOpen: formData.maxOpen,
        dailyLoss: formData.dailyLoss,
        lotPercentage: formData.lotPercentage,
        selectedOption: formData.selectedOption?.value,
        isStoploss: checked,
        pairSelection: formData.pairSelection.map((pair) => pair.value),
      };

      const response = await authService.botConfigUpdate(payload);

      if (response.status) {
        showsuccessToast(
          <div className="toast-ml">
            <h4 className="toast-title">Success!</h4>
            <p className="toast-message">{response.Message}</p>
          </div>
        );

        setFormData({
          maxLimit: "",
          maxOpen: "",
          dailyLoss: "",
          lotPercentage: "",
          selectedOption: null,
          pairSelection: [],
          otp: "",
        });
        setChecked(false);
        handleBotClose();
        await fetchUserDetails();
      } else {
        showerrorToast(
          <div className="toast-ml">
            <h4 className="toast-title">Error!</h4>
            <p className="toast-message">{response.Message}</p>
          </div>
        );
      }
    } catch (error) {
      console.error("Error during botConfigUpdate:", error);
      showerrorToast(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">
            An error occurred while processing the request.
          </p>
        </div>
      );
    } finally {
      setbuttonLoader(false);
    }
  };

  const showError = (field) =>
    touched[field] && validateStep(activeNum)[field] ? (
      <div className="text-red-500 text-sm mt-1 error">
        {validateStep(activeNum)[field]}
      </div>
    ) : null;

  return (
    <>

    
      <div className="bot_modal_head">
        <h4>
          {activeNum === 1
            ? t("policy_pack_configuration")
            : activeNum === 2
            ? t("rpt_settings")
            : activeNum === 3
            ? t("trading_universe")
            : t("stoplossintegration")}
        </h4>

        <span onClick={handleBotClose} className="bot_modal_close">
          <i class="fa-regular fa-circle-xmark"></i>
        </span>
      </div>

      <div className="bot_modal_body">
        {activeNum === 1 && (
          <>
            <div>
              <label htmlFor="max-limit" className="bot_modal_label">
                {t("maximum_orderlimit")}{" "}
                <span>
                  <BsExclamationCircle className="bt_mdl_tootlip_icon" />
                  <div className="bt_tooltip_box">
                    {t("maximumnotionalsize")}
                  </div>
                </span>
              </label>
              <input
                type="number"
                id="max-limit"
                placeholder="Enter the maximum order"
                className="bot_modal_input"
                value={formData.maxLimit}
                onChange={handleInputChange}
                onBlur={() =>
                  setTouched((prev) => ({ ...prev, maxLimit: true }))
                }
              />
              {showError("maxLimit")}
            </div>

            <div className="bot_mdl_mt">
              <label htmlFor="max-open" className="bot_modal_label">
                {t("maximumdailyopened")}
                <span>
                  <BsExclamationCircle className="bt_mdl_tootlip_icon" />
                  <div className="bt_tooltip_box">
                    {t("cumulativenotionalcap")}
                  </div>
                </span>
              </label>
              <input
                type="number"
                id="max-open"
                placeholder="Enter the maximum daily opened"
                className="bot_modal_input"
                value={formData.maxOpen}
                onChange={handleInputChange}
                onBlur={() =>
                  setTouched((prev) => ({ ...prev, maxOpen: true }))
                }
              />
              {showError("maxOpen")}
            </div>

            <div className="bot_mdl_mt">
              <label htmlFor="daily-loss" className="bot_modal_label">
                {t("dailylosslimit")}
                <span>
                  <BsExclamationCircle className="bt_mdl_tootlip_icon" />
                  <div className="bt_tooltip_box">{t("whentodaypnl")}</div>
                </span>
              </label>
              <input
                type="number"
                id="daily-loss"
                placeholder="Enter the daily loss limit"
                className="bot_modal_input"
                value={formData.dailyLoss}
                onChange={handleInputChange}
                onBlur={() =>
                  setTouched((prev) => ({ ...prev, dailyLoss: true }))
                }
              />
              {showError("dailyLoss")}
            </div>

            <div className="bot_mdl_btn_wrap">
              <button className="bot_mdl_btn" onClick={nextStep}>
                {t("next")}
              </button>
            </div>
          </>
        )}

        {activeNum === 2 && (
          <>
            <div>
              <label htmlFor="lot-percentage" className="bot_modal_label">
                {t("lotsizepercentages")}
              </label>
              <input
                type="number"
                id="lot-percentage"
                placeholder="Enter the percentages"
                className="bot_modal_input"
                value={formData.lotPercentage}
                onChange={handleInputChange}
                onBlur={() =>
                  setTouched((prev) => ({ ...prev, lotPercentage: true }))
                }
              />
              {showError("lotPercentage")}

              <div className="bot_mdl_btn_wrap">
                <button className="bot_mdl_btn" onClick={prevStep}>
                  {t("back")}
                </button>
                <button className="bot_mdl_btn" onClick={nextStep}>
                  {t("next")}
                </button>
              </div>
            </div>
          </>
        )}

        {activeNum === 3 && (
  <>
    <div>
      <label htmlFor="pair-selection" className="bot_modal_label">
        {t("pairselection")}
      </label>

      <Select
        options={[{ value: "All Pair Selection", label: "All Pair Selection" }]}
        styles={customStyles}
        className="withdraw-dropdown-menu"
        placeholder="Select a Pair"
        value={{ value: "All Pair Selection", label: "All Pair Selection" }}
        isDisabled={true}
      />

    <div className="mt-3">
  <label className="bot_modal_label">All Pairs</label>
  <div
    className="pair-list-box"
  >
    {pairOptions && pairOptions.length > 0 ? (
      pairOptions.map((pair, index) => (
        <div
          key={index}
          className="pair-flex-change"
        >
          <span className="pair-span-change">{index + 1}.</span>
          <span>{pair.label}</span>
        </div>
      ))
    ) : (
      <p className="no-pair-list">
        No pairs available
      </p>
    )}
  </div>
</div>


      <div className="bot_mdl_btn_wrap">
        <button className="bot_mdl_btn" onClick={prevStep}>
          {t("back")}
        </button>
        <button className="bot_mdl_btn" onClick={nextStep}>
          {t("next")}
        </button>
      </div>
    </div>
  </>
)}


        {activeNum === 4 && (
          <>
            <div className="bot_cnt_flx">
              <span>{t("status")}</span>
              <Switch
                checked={checked}
                onChange={handleChange}
                onColor="#20a1fd"
                offColor="#b0bec5"
                handleDiameter={18}
                height={22}
                width={37}
                uncheckedIcon={false}
                checkedIcon={false}
                handleStyle={{
                  boxShadow: "none",
                  backgroundColor: "white",
                }}
              />
            </div>

            <p className="bt_mdl_cnt">{t("manageyourstoploss")}</p>

            <div className="bot_mdl_mt">
              <label htmlFor="otp" className="bot_modal_label">
                {t("otpconfirmation")}
              </label>
              <div className="bt_mdl_input_wrap pos_rel w-100">
                <input
                  type="number"
                  maxLength={6}
                  id="otp"
                  placeholder="Enter the OTP"
                  className="bot_modal_input"
                  value={formData.otp}
                  onKeyDown={(evt) =>
                    ["e", "E", "+", "-"].includes(evt.key) &&
                    evt.preventDefault()
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 6) {
                      handleInputChange(e);
                    }
                  }}
                  onBlur={() => setTouched((prev) => ({ ...prev, otp: true }))}
                />

                {otpSent ? (
                  <span className="bt_send_btn" style={{ cursor: "default" }}>
                    {t("Resend")} ({timer}s)
                  </span>
                ) : (
                  <span
                    className="bt_send_btn"
                    style={{ cursor: resendLoader ? "wait" : "pointer" }}
                    onClick={() => !resendLoader && sendOtp()}
                  >
                    {resendLoader
                      ? "Loading..."
                      : timer === 300
                      ? "Send OTP"
                      : "Resend"}
                  </span>
                )}
              </div>
              {showError("otp")}
            </div>

            <div className="bot_mdl_btn_wrap">
              <button className="bot_mdl_btn" onClick={prevStep}>
                {t("back")}
              </button>
              <button
                className="bot_mdl_btn"
                onClick={handleSubmit}
                disabled={buttonLoader}
              >
                {buttonLoader ? "Loading..." : "Submit"}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default BotPopup;
